import { Actions, ofType } from '@ngrx/effects';
import { MonoTypeOperatorFunction, takeUntil } from 'rxjs';
import * as Auth from '../actions/auth.actions';

/** Cancel a pending client request when its account session ends or is replaced.
 * Apply inside mergeMap/switchMap so the effect remains available for the next session.
 * Unsubscription does not imply that a server-side mutation was rolled back.
 * Anonymous authMe results are not boundaries: public invitation/document reads remain valid.
 */
export function cancelOnSessionChange<T>(actions: Actions): MonoTypeOperatorFunction<T> {
  return takeUntil(actions.pipe(ofType(
    Auth.logout, Auth.clearUserData,
    Auth.signInWithEmailPassword, Auth.signUpWithEmailPassword,
    Auth.loginWithGithub, Auth.loginAsGuest, Auth.authSignInSuccess,
  )));
}
